import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/votanten/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="DossierVoteVoter"
      returnRoute="/auswahlfelder/dossierVoteVoter"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const DossierVoteVoterRoute = Route;
